import styled from 'styled-components';

export const BoxTitle = styled.p`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
`;

export const Box = styled.div`
  padding: 32px;
  position: relative;
  z-index: 1;
  background-color: ${({ theme }) => theme.colors['neutral-0']};
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors['neutral-30']};
  width: 100%;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08), 0px 1px 2px rgba(0, 0, 0, 0.06);

  &:not(&:last-of-type) {
    margin-bottom: 24px;
  }

  &:has(.dropdown-is-opened),
  &:has(.datepicker.is-opened),
  &:has(.auto-complete-dropdown.is-opened) {
    z-index: 99;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const GapBox = styled.div`
  display: flex;
  gap: 16px;
`;

export const Body = styled.div`
  margin-top: 24px;
`;

export const ToggleShowButton = styled.button`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: ${({ theme }) => theme.colors['primary-60']};
  display: flex;
  align-items: center;

  & > svg {
    font-size: 16px;
    margin-left: 2.5px;
  }
`;
